export const getMessageStatus = (message: any) => {
  if (message?.replied) return 'Replied'
  if (message?.seen) return 'Seen'
  if (message?.sent === true) return 'Sent'
  if (message?.sent === false) return 'Failed'
  return 'Not Sent'
}
